import $ from 'jquery';

const defaults = {
  exclusive: false,
  instanceAttribute: 'data-accordion',
  instanceSelector: '[data-accordion]',
  accordionToggleSelector: '[data-accordion-toggle]',
  accordionItemClass: '.c-zva-accordion__item',
  accordionItemIsActiveClass: 'c-zva-accordion__item--is-active',
};

const init = (opts) => {
  const config = { ...defaults, ...opts };
  const $instances = $(config.instanceSelector);

  $instances.each((index, acc) => {
    const $acc = $(acc);
    const attrConfig = JSON.parse($acc.attr(config.instanceAttribute));
    const instanceConfig = { ...config, ...attrConfig };

    $acc.on('click', instanceConfig.accordionToggleSelector, (event) => {
      const $currentToggle = $(event.target);
      const $currentItem = $currentToggle.parent(instanceConfig.accordionItemClass);
      const $allItems = $acc.find(instanceConfig.accordionItemClass);

      if (instanceConfig.exclusive) {
        $allItems.removeClass(instanceConfig.accordionItemIsActiveClass);
        $currentItem.addClass(instanceConfig.accordionItemIsActiveClass);
      } else {
        $currentItem.toggleClass(instanceConfig.accordionItemIsActiveClass);
      }
      return true;
    });
  });
};

export default {
  init
};



// WEBPACK FOOTER //
// ./modules/accordions.js